import React, { useEffect, createRef } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './ChatBody.module.css';
import Spinner from './Spinner/Spinner';

import TextMessage from '../../chatElements/TextMessage/TextMessage';
import QuickReply from '../../chatElements/QuickReply/QuickReply';
import Carousel from '../../chatElements/Carousel/Carousel';
import Card from '../../chatElements/Card/Card';
import CheckIn from '../../chatElements/CheckIn/CheckIn';
import Image from '../../chatElements/Image/Image';

const ChatBody = (props) => {

    const { t } = useTranslation('global');

    // Reference to scroll the conversation
    const scrollTargetMessage = createRef();

    const selectionHandler = (value, options) => {
        props.sendMsg(value, options);
    }

    useEffect(() => {

        // Scrolling the conversation to the first bubble of the last message
        if (scrollTargetMessage.current) {
            scrollTargetMessage.current.scrollIntoView();
        }
    });

    const processMsgs = (messages) => (
        messages.map((msg, index) => {
            const origin = msg.fromUser ? 'User' : 'Bot';
            switch (msg.type) {
                case 'text':
                    return <TextMessage ref={scrollTargetMessage} key={index} position={msg.position} origin={origin} payload={msg.payload} />
                case 'quick_reply':
                    return <QuickReply key={index} position={msg.position} origin={origin} payload={msg.payload} selected={selectionHandler} />
                case 'carousel':
                    return (
                        <Carousel key={index} position={msg.position} origin={origin}>
                            {processMsgs(msg.payload.items)}
                        </Carousel>
                    )
                case 'card':
                    return <Card key={index} position={msg.position} origin={origin} payload={msg.payload} selected={selectionHandler} />
                case 'checkin':
                    return <CheckIn key={index} position={msg.position} origin={origin} payload={msg.payload} selected={selectionHandler} />
                case 'image':
                    return <Image key={index} origin={origin} payload={msg.payload} />
                default:
                    return <TextMessage key={index} ref={scrollTargetMessage} position={msg.position} origin='Bot' payload={{ text: t('chatbody.error-msg') }} />;
            }
        })
    )

    const msgElements = processMsgs(props.messages);

    return (
        <div
            className={classes.ChatBody}
            style={props.styles}
            tabIndex='0'
            aria-live="polite"
            role="region"
            aria-labelledby="chatContentTitle">
            <h3 id="chatContentTitle" className="sr-only"> {t('chatbody.title')} </h3>
            <div id="MessagesContainer" ref={props.refDiv} className={classes.MessagesContainer}>
                {msgElements}
                {props.showSpinner ? <Spinner /> : ''}
            </div>
        </div>
    )
}

export default ChatBody;